module.exports = __webpack_public_path__ + "static/media/fitness_up.d7f58cf4.webp";